import axios from "axios";
import {
  RESTAURANT_DETAILS_REQUEST,
  RESTAURANT_DETAILS_SUCCESS,
  RESTAURANT_DETAILS_FAIL,
} from "../constants/restaurantConstants";

/* 🍽️ ÉTTEREM ADATOK (subdomain alapján) */
export const getRestaurantDetails = () => async (dispatch) => {
  try {
    dispatch({ type: RESTAURANT_DETAILS_REQUEST });

    const { data } = await axios.get("/api/restaurant/");

    dispatch({
      type: RESTAURANT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: RESTAURANT_DETAILS_FAIL,
      payload:
        error.response?.data?.detail ||
        "Nem sikerült betölteni az étterem adatait.",
    });
  }
};
